const Theme = {
  body_background_color: '#9AAFAA',
  title_font: 'Roboto',
  text_font: 'Roboto',
  text_size: 18,
  subtitleH3_font_weight: '600',
  logo_image_url: 'malvina.png',
  token_url: 'malvina.png',
  number_font: 'Roboto',
  number_color: 'white',
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 0,
  button_color: '#736E69',
  button_hover_text_color: '#736E69',
  button_radius: 100,
  button_outlined_border_color: '#736E69',
  button_outlined_hover_border_color: '#736E69'
}

export default Theme
